import { FunctionComponent } from "react";
import { ExternalLink as ExternalLinkLucide } from "lucide-react";

type ExternalLinkProps = {
    href: string
    text?: string
    children?: React.ReactNode
    className?: string
}

/**
 * ExternalLink component for rendering a link that opens in a new tab
 * @param href - URL for the link
 * @param text - Optional text for the link
 * @param children - Optional React nodes to display inside the link
 * @param className - Additional CSS classes for styling
 * @returns JSX.Element
 */
const ExternalLink: FunctionComponent<ExternalLinkProps> = ({
    href,
    text,
    children,
    className = ""
}) => {
    return (
        <a
            className={`accessible-link ${className}`.trim()}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children || text}
            <span
                aria-hidden="true"
                title="External link"
                className="inline-block vertical-align-middle ml-0.5">
                    <ExternalLinkLucide size={14} />
            </span>
        </a>
    )
}

export default ExternalLink;